// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5bbf1dd1","239":"dcbded40","453":"6d8d583a","667":"1655ddd7"}[chunkId] + ".chunk.js";
};